module.exports = __webpack_public_path__ + "img/recruit3.09da45dc.png";